/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "../../../../../services/googleAnalyticsService";

const TermsOfServiceLegalbirdOSPageMeta = () => {
  const title = "AGB Legalbird OS | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Lesen Sie hier unsere allgemeinen Geschäftsbedingungen von Legalbird OS" />
      <meta name="keywords" content="AGB, Allgemeine Geschäftsbedingungen" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content="Lesen Sie hier unsere allgemeinen Geschäftsbedingungen von Legalbird OS"
      />
    </Helmet>
  );
};

export default TermsOfServiceLegalbirdOSPageMeta;
